import { useFeatureFlags } from 'src/context';
import { useAppBuilderAccess } from 'src/hooks/useAppBuilderAccess';

/**
 * Whether this workspace still runs the old /referrals program. Growth-loops
 * moves referrals into settings, but legacy plans are kept off that page on
 * the same entitlement that keeps them off the app builder, so they stay on
 * the old one.
 */
export const useLegacyReferralProgram = (): boolean => {
  const { EnableGrowthLoops } = useFeatureFlags();
  const { hasAppBuilderPlanAccess, isPlanAccessResolved } =
    useAppBuilderAccess();

  return (
    !EnableGrowthLoops || (isPlanAccessResolved && !hasAppBuilderPlanAccess)
  );
};
